import classNames from 'classnames';
import { BallotCheckIcon, CircleDollarIcon, CrownIcon } from '../../assets/icons';
import { BestValueCardProps } from './interfaces';
import * as styles from './BestValueCard.module.scss';

const defaultList = [
  {
    icon: <BallotCheckIcon />,
    text: (
      <p>
        <strong>Savings.</strong> $15 off each box (that&apos;s $60 saved a year!){' '}
      </p>
    ),
  },
  {
    icon: <CircleDollarIcon />,
    text: (
      <p>
        <strong>Max Choice. </strong> Early access to box customization to snag your faves
      </p>
    ),
  },
  {
    icon: <CrownIcon />,
    text: (
      <p>
        <strong>VIP Treatment. </strong> Exclusive access to our biggest sale events
      </p>
    ),
  },
];

const BestValueCard = ({
  children,
  plan,
  badge,
  className,
  perks = defaultList,
  alignment = 'center',
  size = 'normal',
  onClick,
  priceWrapperClassName,
  badgeAlignment = 'center',
}: BestValueCardProps) => {
  const wrapper = classNames(styles.wrapper, className, {
    [styles.wrapperCenter]: alignment === 'center',
    [styles.wrapperLeft]: alignment === 'left',
    [styles.wrapperLarge]: size === 'large',
  });

  const badgeWrapper = classNames(styles.wrapperBadge, {
    [styles.badgeCenter]: badgeAlignment === 'center',
    [styles.badgeLeft]: badgeAlignment === 'left',
    [styles.badgeRight]: badgeAlignment === 'right',
  });

  return (
    <div
      className={wrapper}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
    >
      {badge && (
        <div className={badgeWrapper}>
          <span className={styles.badge}>{badge}</span>
        </div>
      )}
      {children ? (
        children
      ) : (
        <>
          <div className={classNames(styles.priceWrapper, priceWrapperClassName)}>
            <h3>{plan?.name}</h3>
            <div className={styles.billingData}>
              <h3>{plan?.price}</h3>
              {plan?.billingInformation && (
                <p className={styles.billingInformation}>{plan?.billingInformation}</p>
              )}
            </div>
          </div>
          {perks.length > 0 && (
            <ul className={styles.wrapperList}>
              {perks?.map((perk, index) => (
                <li key={`${index}-${perk.text}`}>
                  <span>{perk.icon}</span>
                  {perk.text}
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};

export default BestValueCard;
